export var BANNER_TYPE = {
  DEFAULT: 'default',
  PRICING: 'pricing'
};
export var DISPLAY_TYPE = {
  FIXED: 'Fixed',
  STICKY: 'Sticky'
};
export var DEFAULT_AUDIENCES = {
  shouldCookieBannerBeVisible: null,
  isAuthenticationRequired: null,
  locales: null,
  urls: null,
  experimentVariations: null
};
export var DEFAULT_RENDER_DELAY = 0;
export var LOCALE_AUDIENCE = {
  EN: 'en',
  ES: 'es'
};